import { back2SummaryList, openShare } from '@/pages/App/native';
import BackArrowIcon from '@/assets/app/back_arrow.svg';
import ShareIcon from '@/assets/app/share.svg';
import UnfoldAudioIcon from '@/assets/app/unfold_audio.svg';

interface IHeaderProps {
  title: string;
  showAudio: boolean;
  setShowAudio: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function Header({
  title,
  showAudio,
  setShowAudio,
}: IHeaderProps) {
  const handleBack = () => {
    back2SummaryList();
  };
  const handleShare = () => {
    openShare();
  };

  const handleUnfoldAudio = () => {
    setShowAudio(true);
  };

  return (
    <div
      className={`flex h-11 items-center justify-center text-center relative ${
        showAudio ? 'mb-4' : 'mb-3.25'
      }`}
    >
      <img
        className="absolute left-0 top-50% translate-y--50% h-4"
        src={BackArrowIcon}
        onClick={handleBack}
      />
      {showAudio ? (
        <div className="max-w-66 font-500 text-mx-secondary text-4 whitespace-nowrap overflow-hidden text-ellipsis">
          {title}
        </div>
      ) : (
        <div
          className="flex items-center justify-center font-500 text-mx-secondary text-4.5"
          onClick={handleUnfoldAudio}
        >
          <img className="w-6 h-6 mr-2" src={UnfoldAudioIcon} />
          展开
        </div>
      )}
      <img
        className="absolute right-0 top-50% translate-y--50% w-6 h-6"
        src={ShareIcon}
        onClick={handleShare}
      />
    </div>
  );
}
